import React from 'react';
import { Widget } from '../Dashboard';
import { useRatingCalculatorMetrics } from '../../rating-calculator/ratingsApi';

export const ratingCalculatorMetricsWidgetTitle = 'Rating calculation processing status';

const RatingCalculatorMetricsWidget = () => {
  const { data: metrics, isError, isInitialLoading: isLoading } = useRatingCalculatorMetrics();

  return (
    <Widget title={ratingCalculatorMetricsWidgetTitle}>
      {isLoading && <p className="apl-px">Loading...</p>}
      {isError && <p className="apl-px">Sorry, there was an error.</p>}
      {metrics && (
        <ul className="widget__list">
          <li className="widget__list-item">
            Ratings waiting to start<span>{metrics.calculationsWaiting}</span>
          </li>
          <li className="widget__list-item">
            Ratings in progress<span>{metrics.calculationsInProgress}</span>
          </li>
          <li className="widget__list-item">
            Ratings completed in the last 15 minutes<span>{metrics.calculationsProcessed}</span>
          </li>
          <li className="widget__list-item">
            Expected time until all ratings are completed
            <span>{metrics.estimatedCompletionTimeInMinutes} minutes</span>
          </li>
        </ul>
      )}
    </Widget>
  );
};

export default RatingCalculatorMetricsWidget;
